import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';
import SearchButton from '../../../../components/DriveItemList/Search/Button';

const searchPathname = '/list/search';

const mapStateToProps = (state: StoreState) => {
	const {
		search: { isShown },
		routing: { locationBeforeTransitions: { pathname } }
	} = state;

	return {
		isActive: isShown || pathname.includes(searchPathname),
	};
};

export default connect(mapStateToProps)(SearchButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemList/Search/Button/index.tsx